import Resource from '@/api/resources/Resource'

class SampleMacroAttachmentService extends Resource {
    async addAttachment(laboratoryId, caseId, sampleId, request) {
        const response = await this.axios.post(
            `/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/macro/attachments`,
            request)
        return response.data
    }

    async getAttachments(laboratoryId, caseId, sampleId) {
        const response = await this.axios.get(`/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/macro/attachments`)
        return response.data
    }

    async deleteAttachment(laboratoryId, caseId, sampleId, descriptionAttachmentId) {
        const response = await this.axios.delete(`/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/macro/attachments/${descriptionAttachmentId}`)
        return response.data
    }
}

export default new SampleMacroAttachmentService()
